module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('event', {
    attrs: {
      "icon": "comment-o",
      "userIcon": _vm.linkedUserConfig.icon,
      "title": _vm.title,
      "content": _vm.content,
      "files": _vm.files,
      "badges": _vm.badges,
      "created": _vm.createdAt,
      "updated": _vm.updatedAt
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41b1d238"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/timeline/events/sms-log/SmsLog.vue
// module id = 2035
// module chunks = 1